module.exports = __webpack_public_path__ + "static/media/referral-program-1.cf73f09a.jpg";